import { TableHeadersType } from '../tableHeadersType';

export const CURRENCY_HEADERS: TableHeadersType[] = [
  {
    "label": "CURRENCY NAME",
    "value": "currency_name",
  
  },
  {
    "label": "CURRENCY SIGN",
    "value": "currency_sign",
  },
  {
    "label": "CURRENCY SHORT FORM",
    "value": "currency_short_form",
  },
  {
    "label": "ADDED/MODIFIED BY",
    "value": "updated_by",
  },
   {
    "label": "ACTION",
    "value": "edit",
  },
];

